<template>
  <div class="item" @click="bindClickPlanItem">
    <img class="item-image" :src="data.cover_img" alt="" />
    <div class="item-right">
      <div class="item-title">{{ data.title }}</div>
      <div class="tag-list">
        <div
          class="tag-item"
          v-for="(item, index) in data.efficacies"
          :key="index"
          >{{ item }}</div
        >
      </div>
      <div class="item-bottom">
        <div class="item-b-left">
          <div class="buji-list" v-if="data.product_images.length">
            <img
              class="buji-item"
              v-for="(item, index) in data.product_images"
              v-show="index < 4"
              :key="index"
              :style="{ transform: 'translateX(' + index * -7 + 'px)' }"
              :src="item"
              alt=""
            />
            <div
              class="item-more iconfont icon-gengduo1"
              v-if="data.product_images.length > 4"
              :style="{
                transform:
                  'translateX(' +
                  (data.product_images.length > 4
                    ? 4
                    : data.product_images.length) *
                    -7 +
                  'px)'
              }"
            ></div>
            <div
              class="item-num"
              :style="{
                transform:
                  'translateX(' +
                  ((data.product_images.length > 4
                    ? 4
                    : data.product_images.length - 1) *
                    -7 +
                    12) +
                  'px)'
              }"
            >
              共{{ data.product_images.length }}种补剂</div
            >
          </div>
        </div>
        <div
          class="item-btn"
          :class="{ 'item-btn-active': data.status == 2 }"
          >{{ data.status == 2 ? '正在使用' : '查看计划' }}</div
        >
      </div>
    </div>
    <!--  <img class="item-image" :src="data.cover_img" alt="">
        <div class="item-use" v-if="data.status == 2">正在使用</div>
        <div class="item-delete iconfont icon-shanchu" v-if="data.status != 2" @click.stop="bindDelete"></div>
        <div class="item-content">
            <div class="item-top">
                <div class="item-title">{{ data.title }}</div>
                <div class="item-time">{{ data.created_at }}创建</div>
            </div>
            <div class="item-bottom">
                <div class="bj-list">
                    <div class="bj-item" v-for="(item, index) in data.product_images" :key="index">
                        <img class="bj-brand" :src="item.brand_img" alt="">
                        <img class="bj-image" :src="item.image" alt="">
                        <div class="bj-right">
                            <div class="bj-name">{{ item.title }}</div>
                            <div class="bj-bottom">
                                <div class="bj-desc">{{ item.use_description }}.{{ item.take_suggested_time_name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClickImage(item) {
      this.$router.push({
        path: '/nutrition-clock/tonic-detail',
        query: {
          id: item.id
        }
      })
    },
    bindClickPlanItem() {
      if (this.data.id) {
        this.$router.push({
          path: '/nutrition-clock/plan-detail',
          query: {
            id: this.data.id,
            isUsed: this.data.status == 2 ? 1 : 0,
            planType: 1
          }
        })
      }
    },
    bindDelete() {
      this.$emit('delete', this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  padding: 10px;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 8px;

  .item-image {
    width: 70px;
    height: 70px;
    border-radius: 6px;
    overflow: hidden;
    object-fit: cover;
    margin-right: 10px;
  }

  .item-right {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .item-title {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 4px;
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;

      .tag-item {
        padding: 0px 3px;
        white-space: nowrap;
        height: 16px;
        background: #fef8e1;
        border-radius: 2px;
        font-size: 10px;
        color: #fe8b1a;
        line-height: 16px;
        margin-right: 6px;
        margin-bottom: 6px;
      }
    }

    .item-bottom {
      display: flex;
      align-items: flex-end;

      .item-b-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        display: flex;
        align-items: center;

        .buji-list {
          display: inline-flex;
          align-items: center;
          justify-content: flex-start;

          .buji-item {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            object-fit: cover;
            overflow: hidden;
            box-sizing: border-box;
            border: 1px solid #ffffff;
          }
        }

        .item-more {
          width: 20px;
          height: 20px;
          box-sizing: border-box;
          border-radius: 50%;
          overflow: hidden;
          background: #f3f3f3;
          border: 1px solid #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
        }

        .item-num {
          white-space: nowrap;
          font-size: 10px;
          color: rgba(0, 0, 0, 0.5);
          line-height: 14px;
        }
      }

      .item-btn {
        text-align: center;
        width: 70px;
        height: 26px;
        line-height: 26px;
        background: #03d4e6;
        border-radius: 14px;
        font-weight: bold;
        font-size: 12px;
        color: #ffffff;
      }
      .item-btn-active {
        background: rgba(3, 212, 230, 0.1);
        color: #00cddf;
      }
    }
  }
}
</style>
